// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GxHkm","title":"styles_title__2vpUx"};